import keyMirror from 'keymirror';

const RunMode = keyMirror({

  DEVELOPMENT: null,
  STAGING: null,
  PILOT: null,
  PRODUCTION: null

});

export default RunMode;



// WEBPACK FOOTER //
// ./src/utils/RunMode.js